import { CartesianChart, type CartesianChartProps } from './CartesianChart';

export type ComposedChartProps = Omit<CartesianChartProps, 'marks'>;

/** Bars with a muted trend line overlaid on the same scale. */
export const ComposedChart = (props: ComposedChartProps) => (
  <CartesianChart {...props} marks='both' />
);

ComposedChart.displayName = 'ComposedChart';
